export const typePaymentSelectType = [
    {
        value: 1,
        label: 'Divisas'
    },
    {
        value: 2,
        label: 'Bolívares'
    }
];